module.exports = __webpack_public_path__ + "img/SignEditorDragAndDrop.53184b56.png";